import React, { FC, useEffect } from 'react'
import { CheckIcon, XIcon, SparklesIcon } from '@heroicons/react/outline'
import { SubscriptionType } from '../../../types/SubscriptionType'
import { YEAR, TRIAL } from '../../utils/stripePrices'
import { StyledSubscriptionSelect, SubscriptionOption } from '.'

type Props = {
  value: SubscriptionType;
  subscriptionList?: SubscriptionType[];
  hideBullets?: boolean;
  onChange: (value: SubscriptionType) => void;
}

const SubscriptionSelect: FC<Props> = ({
  value, subscriptionList, hideBullets, onChange
}) => {
  // fallback on yearly if no subscription is selected yet
  useEffect(() => {
    if (!value) {
      const yearlySub = subscriptionList?.find((sub) => sub.id === YEAR)
      onChange(yearlySub as SubscriptionType)
    }
  }, [])

  return (
    <StyledSubscriptionSelect value={value}>
      {!hideBullets && (
        <ul className="subscription-benefits">
          <li className="paid-subscription">
            {value?.id === TRIAL ? <XIcon /> : <CheckIcon />}
            Instant access to the caption library
          </li>
          <li className="paid-subscription">
            {value?.id === TRIAL ? <XIcon /> : <CheckIcon />}
            Create unlimited number of drafts
          </li>
          <li className="paid-subscription">
            {value?.id === TRIAL ? <XIcon /> : <CheckIcon />}
            Live classes & community support
          </li>
          <div className="annual-sep">
            <span>Annual Membership Only</span>
            <SparklesIcon />
          </div>
          <li className="annual">
            {value?.id === YEAR ? <CheckIcon /> : <XIcon />}A cost savings of $89 compared to the
            monthly plan
          </li>
          <li className="annual">
            {value?.id === YEAR ? <CheckIcon /> : <XIcon />}
            Priority Customer Support
          </li>
        </ul>
      )}
      {subscriptionList
        ?.filter((sub) => !sub.hidden)
        ?.map((subscription) => {
          return (
            <SubscriptionOption
              subscription={subscription}
              onChange={() => onChange(subscription)}
              isSelected={value && value.id === subscription.id}
              isPopular={subscription.id === YEAR}
              key={subscription.id}
            />
          )
        })}
    </StyledSubscriptionSelect>
  )
}

export default SubscriptionSelect
